import { ASSETS, Chapter, Reveal } from "../presentation";

export default function S02Gdansk() {
  return (
    <section id="gdansk" className="about-immersive theme-dark" data-testid="slide-gdansk">
      <div className="about-immersive-media media-right" data-testid="gdansk-media">
        <img src={ASSETS.gdanskShipyard} alt="Sunreef Yachts shipyard — Gdańsk" />
      </div>
      <div className="about-immersive-scrim" />
      <div className="about-immersive-grain" />

      <div className="about-immersive-inner">
        <div className="sec-topbar" style={{ marginBottom: 0 }}>
          <Chapter ch="02" label="gdańsk — poland" testid="gdansk-chapter" />
          <span className="wordmark wordmark-sm">SUNREEF</span>
        </div>

        <div className="about-immersive-content">
          <Reveal><span className="eyebrow">.gdańsk expansion</span></Reveal>
          <Reveal delay={1}>
            <h2 className="editorial editorial-lg" data-testid="gdansk-headline">
              Rapid expansion in the <span className="gold">Gdańsk shipyard.</span>
            </h2>
          </Reveal>

          <Reveal className="hairline-list" as="ol" delay={2} testid="gdansk-list">
            <li data-testid="gdansk-item-01">
              <span className="num">.01</span>
              <span className="content">
                New hall &ldquo;H&rdquo;
                <span className="content-body">Production of Sunreef 70, 80, 100 models, and superyachts.</span>
              </span>
            </li>
            <li data-testid="gdansk-item-02">
              <span className="num">.02</span>
              <span className="content">
                Quay expansion
                <span className="content-body">Relocation of production from the historic Gdańsk shipyard area.</span>
              </span>
            </li>
          </Reveal>

          <Reveal className="stat-row" delay={3} testid="gdansk-stats">
            <div className="stat">
              <span className="stat-num">2000<span className="stat-unit">~</span></span>
              <span className="stat-label">.employees</span>
            </div>
            <div className="stat">
              <span className="stat-num">3<span className="stat-unit">×140ft</span></span>
              <span className="stat-label">.superyachts in build</span>
            </div>
            <div className="stat">
              <span className="stat-num">12<span className="stat-unit">×100ft</span></span>
              <span className="stat-label">.superyachts in build</span>
            </div>
          </Reveal>
        </div>

        <div className="about-immersive-foot">
          <span className="about-caption about-caption-corner" aria-hidden="true"></span>
        </div>
      </div>
    </section>
  );
}
